<template>
  <div :aria-hidden="(fieldData.sub_text === '') ? 'true' : 'false'" class="field-subtext pr-2" :id="(fieldData.sub_text === '') ? `${fieldData.field_name}_describedby` : `${fieldData.field_name}_non` ">
    <div :id="`${fieldData.field_name}_describedby`" v-on:click.capture="generate_rnd_email_address($event, fieldData.field_name)" class="form-text smaller-font-content" v-if="fieldData.sub_text" v-html="fieldData.sub_text"></div>
  </div>
</template>

<script>
import moment from 'moment';
/* eslint-disable */
export default {
  props: ["fieldData"],
  methods: {
    /* eslint object-shorthand:  */
    /* eslint func-names: [0] */
    moment: function (newDate) {
      let dateParts;

      if (!newDate) {
        return moment();
      }

      if (typeof newDate.getMonth === 'function') {
        return moment(newDate);
      }

      dateParts = newDate.split('/');

      return moment(new Date(dateParts[2], (dateParts[0] - 1), dateParts[1]));
    },
    /**
     * Generate a random, unique email address. This ensure uniqueness
     * by using the current time's timestamp.
     */
    generate_rnd_email_address(e, fieldToUpdate) {
      console.log('event', e);
      if (e.target.dataset.action === 'generate-email-address') { // TODO: Use config value
        e.preventDefault();
        this.fieldData.field_value = `quote${this.moment()}@example.com`; // TODO: Use config value

        // TODO: Move validation to update() . This hack allows validation to see the value immediately.
        document.getElementById(fieldToUpdate).value = this.fieldData.field_value;
      }
    },
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/presentational/FieldSubtext.vue?4a83f5f0